import cn from "classnames";
import styles from "./ProductFiles.module.sass";
import Card from "../../../../components/Card";
import File from "../../../../components/File";
import Control from "./Control";

const ProductFiles = ({ className, offer, onOfferChange, loading, onSave }) => {
    
    const handleFileChange = (file) => {
        if (onOfferChange && file) {
            // Stocker le fichier entier pour l'upload vers PocketBase
            onOfferChange({
                target: {
                    name: 'job_description',
                    value: file 
                }
            });
            console.log('Fichier sélectionné:', file.name, file.type, file.size);
        }
    };

    const handleFileRemove = () => {
        if (onOfferChange) {
            onOfferChange({
                target: {
                    name: 'job_description',
                    value: null
                }
            });
        }
    };

    const handleFileDownload = () => {
        if (hasExistingFile && selectedFile) {
            // Construire l'URL de téléchargement du fichier depuis PocketBase
            const baseUrl = process.env.REACT_APP_POCKETBASE_URL || 'http://127.0.0.1:8090';
            const downloadUrl = `${baseUrl}/api/files/${offer.collectionId}/${offer.id}/${selectedFile}`;
            
            console.log("Téléchargement du fichier:", downloadUrl);
            // Ouvrir le fichier dans un nouvel onglet pour le téléchargement
            window.open(downloadUrl, '_blank');
        }
    };

    // Vérifier si un fichier est sélectionné (nouveau fichier) ou existe déjà (fichier de l'offre)
    const selectedFile = offer?.job_description;
    
    // Cas 1: Nouveau fichier sélectionné (objet File)
    const hasNewFile = selectedFile && typeof selectedFile === 'object' && selectedFile.name && selectedFile.size;
    
    // Cas 2: Fichier existant dans l'offre (string filename de PocketBase dans job_description)
    const hasExistingFile = selectedFile && typeof selectedFile === 'string' && selectedFile.length > 0;
    
    const hasFile = hasNewFile || hasExistingFile;
    
    console.log("ProductFiles - Debug fichier:", {
        selectedFile,
        hasNewFile,
        hasExistingFile,
        hasFile,
        offerJobDescription: offer?.job_description
    });

    return (
        <Card
            className={cn(styles.card, className)}
            title="Fiche de poste"
            classTitle="title-blue"
        >
            <div className={styles.files}>
                {!hasFile ? (
                    <File
                        className={styles.field}
                        title="Déposer un fichier"
                        label="Fiche de poste (optionnel)"
                        tooltip="Formats acceptés: PDF, DOC, DOCX. Taille maximum: 10MB"
                        onChange={handleFileChange}
                    />
                ) : (
                    <div className={styles.field}>
                        <div className={styles.label}>
                            Fiche de poste (optionnel)
                        </div>
                        <div className={styles.fileSelected}>
                            <div className={styles.fileInfo}>
                                <div className={styles.avatar}>
                                    <img src={'/images/content/convention_logo.png'} alt="Logo" />
                                </div>
                                {hasNewFile ? (
                                    // Affichage pour un nouveau fichier sélectionné
                                    <>
                                        <span className={styles.fileName}>{selectedFile.name}</span>
                                        <span className={styles.fileSize}>
                                            ({(selectedFile.size / 1024).toFixed(1)} KB)
                                        </span>
                                    </>
                                ) : hasExistingFile ? (
                                    // Affichage pour un fichier existant dans l'offre
                                    <>
                                        <span className={styles.fileName}>{selectedFile}</span>
                                    </>
                                ) : null}
                            </div>
                            <Control
                                offer={offer}
                                selectedFile={selectedFile}
                                hasNewFile={hasNewFile}
                                hasExistingFile={hasExistingFile}
                                onFileRemove={handleFileRemove}
                                onFileDownload={handleFileDownload}
                            />
                        </div>
                    </div>
                )}
            </div>

        </Card>
    );
};

export default ProductFiles;
